import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITranslatableText } from 'src/app/store/services/store.service';
import { SettingService } from './setting.service';
import { ApiControllerService } from './api-controller.service';

export interface IBaseGameRequest {
  merchantId: string;
}

export interface IGames {
  id: string;
  merchantId: string;
  title: ITranslatableText;
  homePageDescription: ITranslatableText;
  homePagePlayBtnColorGradient1?: string;
  homePagePlayBtnColorGradient2?: string;
  games: IGameConfig[];
}

export interface IGameConfig {
  id: string;
  gameName: ITranslatableText;

  // actual game config
  gameReference?: string;
  attempts?: number;
  userTimer?: boolean;
  timeAllowedInSeconds?: number;
  limitedMoves?: boolean;
  numberOfMoves?: number;
  minimumLengthForPoints?: number;
  minimumPointsGain?: number;
  pointsMutiplier?: number;
  bonusPointsMultiGroups?: number;
  cellWidth?: number;
  cellHeight?: number;
  cols?: number;
  rows?: number;
  gameBackgroundColor: string; // for now just do an empty string
  rewardedPointsName: ITranslatableText; // a field where you enter whatever the name of your point system. for example, homers calls their points wallet "sprinkles"
  earnedPointsOnSuccess: number; // assigned rewarded account points

  //links?: string;
  deactivate: ITranslatableText;
  creationDate?: string;
  editingDate?: string;
  createdBy?: string;
  lastEditedBy?: string;
}

@Injectable({
  providedIn: 'root',
})
export class GamesService {

  games: IGames;
  
  constructor(
    private http: HttpClient, 
    private setting: SettingService,
    private apiController: ApiControllerService
  ) { }

  getGames(gamesRequest: IBaseGameRequest): Observable<IGames> {
    return Observable.create(o => {
      if (!this.games) {
        /* this.http.post(this.setting.apiUrl('Game/GetGames'), gamesRequest)
          .subscribe((data: any) => {

            this.games = data;
            o.next(data);
            o.complete();
          }); */
        this.apiController.post(this.setting.apiUrl('Game/GetGames'), gamesRequest)
          .subscribe((data: any) => {

            this.games = data;
            o.next(data);
            o.complete();
          });

      } else {
        o.next(this.games);
        o.complete();
      }


    })
  }
}
